import React, { FC } from 'react'
import styled from 'styled-components'
import { FontSize } from 'styles/fontSize'
import { Icon as BaseIcon } from 'components/base-ui'

interface LabelWithIconProps {
  title: string
  size?: keyof FontSize
  color?: string
  bold?: boolean
  iconName: string
  iconSize?: string
  iconColor?: string
}
const LabelWithIcon: FC<LabelWithIconProps> = ({ title, size = 'sm', bold, color, iconName, iconSize, iconColor }) => {
  return (
    <Wrapper color={color}>
      <Icon name={iconName} size={iconSize} color={iconColor ? iconColor : color} />
      <Label size={size} bold={bold}>
        {title}
      </Label>
    </Wrapper>
  )
}

export default LabelWithIcon

interface LabelProps {
  size: keyof FontSize
  bold?: boolean
}

const Wrapper = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  color: ${({ color, theme: { colors } }) => (color ? color : colors.black)};
`

const Label = styled.span<LabelProps>`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ size, theme }) => theme.fontSize[size]};
`

const Icon = styled(BaseIcon)<{ color: string }>`
  margin-right: 10px;
  :before {
    color: ${({ theme, color }) => (color ? color : theme.colors.primary)};
  }
`
